import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  WorkOrderV2ProductDeliveryResponse,
  WorkOrdersV2Request,
  WorkOrdersV2Response,
  WorkOrdersV2UfosAvailabilityResponse,
  WorkOrderV2StatusListResponse,
  WorkOrderV2StatusPayload,
  WorkOrderV2StatusResponse,
} from './work-orders-v2.models';

@Injectable({
  providedIn: 'root'
})
export class WorkOrdersV2Service {
  private readonly endpoint = '/api/work_orders/work_orders_v2.php';
  private readonly statusEndpoint = '/api/work_orders/work_order_status_timeline.php';
  private readonly productDeliveryEndpoint = '/api/work_orders/lading_product_delivery.php';

  constructor(private readonly http: HttpClient) {}

  load(request: WorkOrdersV2Request): Observable<WorkOrdersV2Response> {
    return this.http.post<WorkOrdersV2Response>(this.endpoint, request);
  }

  loadUfosAvailability(ladingUuids: string[]): Observable<WorkOrdersV2UfosAvailabilityResponse> {
    return this.http.get<WorkOrdersV2UfosAvailabilityResponse>('/api/roswell/availability.php', {
      params: { lading_uuids: ladingUuids.join(',') },
    });
  }

  addStatus(payload: WorkOrderV2StatusPayload): Observable<WorkOrderV2StatusResponse> {
    return this.http.post<WorkOrderV2StatusResponse>(this.statusEndpoint, payload);
  }

  loadStatusTimeline(ladingUuid: string): Observable<WorkOrderV2StatusListResponse> {
    return this.http.get<WorkOrderV2StatusListResponse>(this.statusEndpoint, {
      params: { lading_uuid: ladingUuid },
    });
  }

  updateStatus(payload: WorkOrderV2StatusPayload): Observable<WorkOrderV2StatusResponse> {
    return this.http.put<WorkOrderV2StatusResponse>(this.statusEndpoint, payload);
  }

  getProductDeliveryPreview(ladingUuid: string): Observable<WorkOrderV2ProductDeliveryResponse> {
    return this.http.get<WorkOrderV2ProductDeliveryResponse>(this.productDeliveryEndpoint, {
      params: { lading_uuid: ladingUuid },
    });
  }

  markProductsDelivered(
    ladingUuid: string,
    deliveredTimeUtc: string,
  ): Observable<WorkOrderV2ProductDeliveryResponse> {
    return this.http.post<WorkOrderV2ProductDeliveryResponse>(this.productDeliveryEndpoint, {
      lading_uuid: ladingUuid,
      delivered_time: deliveredTimeUtc,
    });
  }
}
